var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg43(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5293 18.5V24.1471",
    stroke: "black",
    strokeWidth: 1.41176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2933 14.2646H0.705078V18.4999H23.2933V14.2646Z",
    stroke: "black",
    strokeWidth: 1.41176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4707 18.5V24.1471",
    stroke: "black",
    strokeWidth: 1.41176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17578 12.5001C9.17578 13.4747 9.96585 14.2648 10.9405 14.2648H21.1758V10.7354H10.9405C9.96585 10.7354 9.17578 11.5254 9.17578 12.5001Z",
    stroke: "black",
    strokeWidth: 1.41176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41119 14.2648C8.38581 14.2648 9.1759 13.4747 9.1759 12.5001C9.1759 11.5254 8.38581 10.7354 7.41119 10.7354C6.43657 10.7354 5.64648 11.5254 5.64648 12.5001C5.64648 13.4747 6.43657 14.2648 7.41119 14.2648Z",
    stroke: "black",
    strokeWidth: 1.41176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3526 10.735H14.8231V9.303C14.8231 8.85006 14.7367 8.40126 14.5685 7.98069L14.3102 7.3349C13.8797 6.25862 14.6723 5.08789 15.8315 5.08789C16.5015 5.08789 17.1039 5.4958 17.3528 6.11787L17.5661 6.65114C18.0856 7.95001 18.3526 9.33608 18.3526 10.735Z",
    stroke: "black",
    strokeWidth: 1.41176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1165 7.20605L11.293 10.7355",
    stroke: "black",
    strokeWidth: 1.41176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5293 21.3232H20.4705",
    stroke: "black",
    strokeWidth: 1.41176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4698 5.08801C15.4444 5.08801 16.2345 4.29792 16.2345 3.3233C16.2345 2.34868 15.4444 1.55859 14.4698 1.55859C13.4952 1.55859 12.7051 2.34868 12.7051 3.3233C12.7051 4.29792 13.4952 5.08801 14.4698 5.08801Z",
    stroke: "black",
    strokeWidth: 1.41176,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg43);
export default __webpack_public_path__ + "static/media/43.b0db5edb8451d9113f289a50a24470e1.svg";
export { ForwardRef as ReactComponent };